import { render, staticRenderFns } from "./shipping-quote-request-patient-details-modal.vue?vue&type=template&id=c42f6f34&scoped=true&lang=pug&"
import script from "./shipping-quote-request-patient-details-modal.vue?vue&type=script&lang=ts&"
export * from "./shipping-quote-request-patient-details-modal.vue?vue&type=script&lang=ts&"
import style0 from "./shipping-quote-request-patient-details-modal.vue?vue&type=style&index=0&id=c42f6f34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42f6f34",
  null
  
)

export default component.exports